import { IHaulierOption } from "../../utils/hauliers";
import { cellInputClasses } from "./WasteReceiptEditableCell";

const NEW_HAULIER = "__new__";

interface HaulierCellProps {
  value: string | null | undefined;
  options: IHaulierOption[];
  onPick: (haulierAccountId: string | null) => void;
  onCreate: () => void;
  disabled?: boolean;
  width?: string;
}

// Haulier picker shown under the carrier type on third-party rows. Hauliers are accounts flagged
// isHaulier. "No saved haulier" keeps the row on manual entry; the last option opens the account
// form instead of committing.
export function WasteReceiptHaulierCell({ value, options, onPick, onCreate, disabled = false, width = "w-44" }: HaulierCellProps) {
  return (
    <div className={width} onClick={(e) => e.stopPropagation()}>
      <select
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => {
          const picked = e.target.value;
          if (picked === NEW_HAULIER) {
            onCreate();
            // Leave the select where it was; the modal's save commits the new haulier.
            e.target.value = value ?? "";
            return;
          }
          onPick(picked === "" ? null : picked);
        }}
        className={cellInputClasses}
        aria-label="Haulier"
      >
        <option value="">No saved haulier (type details)</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
        {!disabled && <option value={NEW_HAULIER}>+ Add new haulier…</option>}
      </select>
    </div>
  );
}
